import { CompanionAd, ResourceType } from '../model/CompanionAd';

const JS_BANNER_URL = 'https://player.tritondigital.com/tpl/default/jsbanner.php';

export function loadVASTCompanionAd(container: Element, companionAd: CompanionAd): void {
  switch (companionAd.resourceType) {
    case ResourceType.STATIC:
      if (companionAd.creativeType == 'text/javascript' && companionAd.url) {
        companionAd.resourceType = ResourceType.IFRAME;
        companionAd.url = JS_BANNER_URL + '?code=' + encodeURIComponent(companionAd.url);
        loadVASTCompanionAd(container, companionAd);
      } else {
        loadCompanionStatic(
          container,
          companionAd.width,
          companionAd.height,
          companionAd.url,
          companionAd.clickThroughURL,
          companionAd.altText,
        );
      }
      break;
    case ResourceType.IFRAME:
      loadCompanionIframe(container, companionAd.url, companionAd.height, companionAd.width);
      break;
    case ResourceType.HTML:
      if (companionAd.code) {
        if (companionAd.code.indexOf('<script>') > -1 && companionAd.code.indexOf('document.write') > -1) {
          container.innerHTML = companionAd.code;
        } else if (companionAd.code.indexOf('document.write') > -1) {
          companionAd.resourceType = ResourceType.IFRAME;
          companionAd.url = JS_BANNER_URL + '?code=' + encodeURIComponent(companionAd.code);
          loadVASTCompanionAd(container, companionAd);
        } else {
          container.innerHTML = companionAd.code;
        }
      }
      break;
  }
}

function loadCompanionIframe(container: Element, adSpotUrl?: string, width?: number, height?: number): void {
  if (adSpotUrl && height && width) {
    const iframe: HTMLElement = document.createElement('iframe');
    addOrUpdateCompanionContainerAttributes(iframe, {
      src: adSpotUrl,
      height: height.toString(),
      width: width.toString(),
      frameborder: '0',
      marginheight: '0',
      marginwidth: '0',
      allowtransparency: 'true',
      margin: '0',
      padding: '0',
    });
    container.appendChild(iframe);
  }
}

function addOrUpdateCompanionContainerAttributes(element: Element, attributes: { [key: string]: string }): void {
  Object.keys(attributes).forEach(key => {
    const val = attributes[key];
    element.setAttribute(key, val);
  });
}

function loadCompanionStatic(
  container: Element,
  width: number,
  height: number,
  adSpotUrl?: string,
  clickThroughURL?: string,
  altText?: string,
): void {
  let imgHtml = '';
  altText = altText ?? '';
  if (clickThroughURL != undefined) {
    imgHtml = '<a href="' + clickThroughURL + '" target="_blank">';
  }
  imgHtml +=
    '<img src="' + adSpotUrl + '" width="' + width + '" height="' + height + '" title="' + altText + '" border="0"/>';
  if (clickThroughURL != undefined) {
    imgHtml += '</a>';
  }

  container.innerHTML = imgHtml;
}
